import _ from 'lodash';
import { SET_FEATURED_STREAMERS, SET_IS_LOADING } from '../actions/featuredStreamersActionCreator';
import { TAction } from '../actions/types/action';

export default function featuredStreamersActionCreator(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_FEATURED_STREAMERS: {
      const typeId = `TYPE_${action.payload.type}`;
      return {
        ...state,
        [typeId]: {
          ...state[typeId],
          ...action.payload.data
        }
      };
    }
    case SET_IS_LOADING: {
      const typeId = `TYPE_${action.payload.type}`;
      return {
        ...state,
        [typeId]: {
          ...state[typeId],
          isLoading: action.payload.isLoading
        }
      };
    }
    default: {
      return state;
    }
  }
}
